import { ajaxController } from "./controller/AjaxController";
import { PagedResult } from "../DTOs/Common/PagedResult";
import { PolicyMode } from "../DTOs/apiEnums.generated";
import {
  BulkClosePreviewDTO,
  DrillBlastPolicyChangeDTO,
  DrillBlastSettingsDTO,
  SaveSurveyControlPointRequest,
  SurveyGridDTO
} from "../DTOs/DrillBlast/DrillBlastSettingsDTO";

class DrillBlastSettingsAjax {
  private _ajaxController = ajaxController;
  private _endpoint = "/DrillBlastSettings";

  public getSettings() {
    return this._ajaxController.get<DrillBlastSettingsDTO>(this._endpoint, {});
  }

  public getChanges(take = 200) {
    return this._ajaxController.get<PagedResult<DrillBlastPolicyChangeDTO>>(`${this._endpoint}/changes`, { take });
  }

  public setSetting(key: string, value: string, reason?: string) {
    return this._ajaxController.put<{ value: string; reason?: string }, DrillBlastSettingsDTO>(
      `${this._endpoint}/settings/${encodeURIComponent(key)}`,
      { value, reason }
    );
  }

  public getSurveyGrid() {
    return this._ajaxController.get<SurveyGridDTO>(`${this._endpoint}/survey`, {});
  }

  public saveControlPoint(id: number | null, request: SaveSurveyControlPointRequest) {
    return id == null
      ? this._ajaxController.post<SaveSurveyControlPointRequest, SurveyGridDTO>(`${this._endpoint}/survey/points`, request)
      : this._ajaxController.put<SaveSurveyControlPointRequest, SurveyGridDTO>(`${this._endpoint}/survey/points/${id}`, request);
  }

  public deleteControlPoint(id: number) {
    return this._ajaxController.delete<SurveyGridDTO>(`${this._endpoint}/survey/points/${id}`);
  }

  public previewBulkClose(before: string) {
    return this._ajaxController.get<BulkClosePreviewDTO>(`${this._endpoint}/bulk-close`, { before });
  }

  public bulkClose(before: string, reason: string) {
    return this._ajaxController.post<{ before: string; reason: string }, number>(`${this._endpoint}/bulk-close`, { before, reason });
  }

  public setPolicy(rule: string, mode: PolicyMode, reason?: string) {
    return this._ajaxController.put<{ mode: PolicyMode; reason?: string }, DrillBlastSettingsDTO>(
      `${this._endpoint}/policies/${encodeURIComponent(rule)}`,
      { mode, reason }
    );
  }
}

export const drillBlastSettingsAjax = new DrillBlastSettingsAjax();
